import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 解决点击路由重复点击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/home/Home.vue")
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/login/Login.vue")
    },
    {
      path: "/record",
      name: "Record",
      component: () => import("../views/record/Record.vue")
    },
    {
      path: "/list",
      name: "List",
      component: () => import("../views/list/List.vue")
    },
    {
      path: "/detail",
      name: "Detail",
      component: () => import("../views/detail/Detail.vue")
    },
    {
      path: "/news",
      name: "News",
      component: () => import("../views/news/News.vue")
    },
    {
      path: "/searchList",
      name: "searchList",
      component: () => import("../views/searchList/searchList.vue")
    }
  ]
});
